import React from 'react';
import type { ReactNode } from 'react';
import { CLAIM_MINE } from '../../util_components/instant_alert/claim';
import type { ClaimState } from '../../util_components/instant_alert/claim';
import { timer_color_token_css as timerColorTokenCss } from '../../util_components/instant_alert/instant_timer';
import {
  PHASE_COLOR,
  claim_remaining_ms,
  format_hold,
  hold_forces_read_only,
  hold_phase
} from './claim_hold';
import { hold_banner_tone } from './form_view';
import { Banner, Btn } from './ui';

interface Props {
  claim: ClaimState;
  now_ms: number;
  on_release: () => void;
  on_reopen: () => void;
  releasing?: boolean;
  assign_slot?: ReactNode;
  // Phones get 44px buttons.
  touch?: boolean;
}

function ClaimCountdownBanner({
  claim,
  now_ms,
  on_release,
  on_reopen,
  releasing = false,
  assign_slot = null,
  touch = false
}: Props) {
  const size = touch ? 'touch' : 'row';
  if (hold_forces_read_only(claim, now_ms)) {
    return (
      <div role="status" data-testid="claim-hold-banner">
        <Banner
          tone="neutral"
          actions={
            <Btn size={size} onClick={on_reopen}>
              Reopen
            </Btn>
          }
        >
          <span className="font-semibold">Returned to pool — reopen to claim</span>
        </Banner>
      </div>
    );
  }
  if (claim.state !== CLAIM_MINE) return null;

  const remaining = claim_remaining_ms(claim, now_ms);
  const timed = Number.isFinite(remaining);
  const phase = hold_phase(remaining);
  return (
    <div role="status" data-testid="claim-hold-banner" data-phase={timed ? phase : 'untimed'}>
      <Banner
        tone={hold_banner_tone(timed ? phase : 'untimed')}
        actions={
          <>
            {assign_slot}
            <Btn size={size} onClick={on_release} disabled={releasing}>
              {releasing ? 'Releasing…' : 'Release'}
            </Btn>
          </>
        }
      >
        <span className="font-semibold">Held by you</span>
        {timed ? (
          <>
            {' · returns to pool in '}
            <span
              style={{
                color: timerColorTokenCss(PHASE_COLOR[phase]),
                fontWeight: 700,
                fontVariantNumeric: 'tabular-nums'
              }}
            >
              {format_hold(remaining)}
            </span>
            {' without activity (call, message or outcome)'}
          </>
        ) : null}
      </Banner>
    </div>
  );
}

export default ClaimCountdownBanner;
